import { render, staticRenderFns } from "./TryNewAtlasBanner.vue?vue&type=template&id=219a0050&scoped=true"
import script from "./TryNewAtlasBanner.vue?vue&type=script&lang=ts"
export * from "./TryNewAtlasBanner.vue?vue&type=script&lang=ts"
import style0 from "./TryNewAtlasBanner.vue?vue&type=style&index=0&id=219a0050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219a0050",
  null
  
)

export default component.exports